import { Component, Input, type OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-multiline-text-cell',
    templateUrl: './multiline-text-cell.component.html',
    styleUrls: ['./multiline-text-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultilineTextCellComponent {
  accessor dataContext: string[];
}
